import { push } from 'connected-react-router';
import { Message } from './types';
import { ModalImages } from '../modals/types';
import { store } from '../../app/store';
import { hideModal } from '../modals/modalsSlice';
import { AppRoute } from '../../const';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';

const getDefaultMessage = (): Message => ({
  title: 'Что-то пошло не так :(',
  message: 'Попробуйте позднее',
  imageClass: ModalImages.Cry,
});
const getGiftWasPreviouslySentMessage = (partner: string): Message => ({
  title: 'Упс!',
  message: 'Этот подарок уже отправлен,<br> второй такой же можно отправить<br> через 1 час.',
  imageClass: ModalImages.Wait,
  buttonFirst: {
    text: 'Выбрать новый подарок',
    onClick: () => {
      store.dispatch(hideModal());
      trackEventBound(
        EventGTM.MakeActions,
        EventId.ClickButtonInSubscriptionGiftFailureModal,
        EventCat.Gift,
        EventName.ClickElement,
        `${partner} / Выбрать новый подарок`
      );
    },
  },
});

const getMessageFromCode = (code: number, partner: string): Message => {
  switch (code) {
    case 200:
      return {
        title: 'Успешно!',
        message:
          'Промокод на подарок отправлен<br> на указанный email. Статус его активации смотрите во вкладке «Мои заказы»',
        imageClass: ModalImages.Gift,
        buttonFirst: {
          text: 'Подарить еще',
          onClick: () => {
            store.dispatch(hideModal());
            trackEventBound(
              EventGTM.MakeActions,
              EventId.ClickButtonInSubscriptionGiftFailureModal,
              EventCat.Gift,
              EventName.ClickElement,
              `${partner} / Подарить еще`
            );
          },
        },
        buttonSecond: {
          text: 'Поcмотреть статус',
          onClick: () => {
            store.dispatch(push(AppRoute.ORDERS));
            store.dispatch(hideModal());
            trackEventBound(
              EventGTM.MakeActions,
              EventId.ClickButtonInSubscriptionGiftFailureModal,
              EventCat.Gift,
              EventName.ClickElement,
              `${partner} / Поcмотреть статус`
            );
          },
        },
      };
    case 411:
      return getGiftWasPreviouslySentMessage(partner);
    case 415:
      return {
        title: 'Ой!',
        message:
          'На вашем номере действует запрет на подключение услуг.<br> Позвоните по бесплатному номеру <a href="tel:0500">0500</a>,<br> чтобы снять ограничения',
        imageClass: ModalImages.Cry,
      };
    case 417:
      return {
        title: 'Слишком много попыток!',
        message: 'Вы уже подключали услугу. <br> Повторите попытку завтра.',
        imageClass: ModalImages.Wait,
      };
    case 501:
      return {
        title: 'Недостаточно средств',
        message: 'Пополнить баланс быстро<br> и без комиссии можно<br> на нашем сайте',
        imageClass: ModalImages.Cry,
        buttonFirst: {
          text: 'Пополнить баланс',
          url: 'https://pay.megafon.ru',
          onClick: () => {
            trackEventBound(
              EventGTM.MakeActions,
              EventId.ClickButtonInSubscriptionGiftFailureModal,
              EventCat.Gift,
              EventName.ClickElement,
              `${partner} / Пополнить баланс`
            );
          },
        },
      };
    case 506:
      return getGiftWasPreviouslySentMessage(partner);
    case 500:
      return getDefaultMessage();
    default:
      return getDefaultMessage();
  }
};

export default getMessageFromCode;
